import React, { useState, useEffect }
  from 'react';
import PropTypes from 'prop-types';

const TierAllocationBlock = ({
  tierAllocTitle,
  beneficialOwner,
  details,
  displayTierAllocationValue,
  isEdit,
  onTierAllocationChange,
  isImyLayer,
  disabled,
  formatPercentage
}) => {
  const [inputValue, setInputValue] = useState(formatPercentage(details.tierAllocation, 8) ?? '');

  const handleBlur = () => {
    onTierAllocationChange(inputValue);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    setInputValue(formatPercentage(details.tierAllocation, 8) ?? '');
  }, [details.tierAllocation, formatPercentage]);

  return (
    <div className="allocation-group">
      <div className="allocation-title">
        {tierAllocTitle}
      </div>
      {(!isEdit)
      && <div
        className="allocation-value"
        data-testid="label-tier-allocation"
      >
        {displayTierAllocationValue(beneficialOwner)} %
      </div>}
      {(isEdit)
      && <div className="tier-allocation-input">
        <input
          type="number"
          value={ inputValue }
          onChange={ handleChange }
          onBlur={ handleBlur }
          data-testid="field-tier-allocation-value"
          disabled={ disabled }
        />
        <span className="percentage-symbol"> %</span>
      </div>}
    </div>
  );
};

TierAllocationBlock.propTypes = {
  tierAllocTitle: PropTypes.string.isRequired,
  beneficialOwner: PropTypes.shape().isRequired,
  details: PropTypes.shape({
    tierAllocation: PropTypes.number
  }).isRequired,
  displayTierAllocationValue: PropTypes.func.isRequired,
  isEdit: PropTypes.bool.isRequired,
  onTierAllocationChange: PropTypes.func.isRequired,
  isImyLayer: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  formatPercentage: PropTypes.func.isRequired
};

export default TierAllocationBlock;
